module.exports = __webpack_public_path__ + "img/c-hr.9beca36e.png";